import { render, staticRenderFns } from "./SithMesStoolTransferTicketDetailEdit.vue?vue&type=template&id=af5bb21a&"
import script from "./SithMesStoolTransferTicketDetailEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolTransferTicketDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports